export enum DigihavenFakeQueryPartFields {
    ChildrenAndCandidateChildren = 'ChildrenAndCandidateChildren'
}

export class DigihavenQueryPartsHelper {
    static getActualCorrespondingQueryPartFields(fakeField: DigihavenFakeQueryPartFields): string[] {
        if (fakeField === DigihavenFakeQueryPartFields.ChildrenAndCandidateChildren) {
            return ['RelationsIsCandidateChildOf', 'ReferenceCodesDossier'];
        }

        return [];
    }
}
